module.exports = __webpack_public_path__ + "img/companyInfoBottomIcon.74f092ef.svg";